(function () {
    "use strict";

    angular.module("app").factory("commentsService", CommentsServiceFactory);

    CommentsServiceFactory.$inject = ["rx", "webApiServices", "notificationService"];
    function CommentsServiceFactory(rx, webApiServices, notificationService) {
        const dataStore = {
            DossierId: null,
            RequestId: null,
            ICD: null
        };

        const service = {
            Initialize: initialize,
            get DossierId() { return dataStore.DossierId; },
            get RequestId() { return dataStore.RequestId; },
            // Required for the new-comment component
            get ICD() { return dataStore.ICD; },
            get OrganisationId() { return dataStore.OrganisationId; },
            // Observability
            Dossier$: CreateCommentObservable(rx),
            Request$: CreateCommentObservable(rx),
        };

        function initialize(data) {
            dataStore.RequestId = data.RequestId || null;
            dataStore.DossierId = data.DossierId || null;
            dataStore.RequestLoader = data.RequestLoader || webApiServices.GetAllRequestComments;
            dataStore.ICD = data.ICD || null;
            dataStore.OrganisationId = data.OrganisationId || null;

            loadAll();
        }

        function loadAll() {
            if (service.DossierId !== null)
                load(webApiServices.GetAllDossierComments, { PublicId: service.DossierId }, service.Dossier$);
            if (service.RequestId !== null)
                load(dataStore.RequestLoader, { PublicId: service.RequestId }, service.Request$);
        }

        function load(api, payload, observable) {
            if (payload === null)
                return;

            api(
                payload,
                (result) => {
                    if (!CheckResultReceived(result))
                        return;
                    observable.set(result.data);
                },
                (err) => DoShowError(notificationService, err)
            );
        }

        return service;
    }

    function CreateCommentObservable(rx) {
        const subject = new rx.Subject();
        let data = {};

        return {
            set: function set(d) {
                data = d;
                subject.onNext(d);
            },
            get: function get() {
                return data;
            },
            subscribe: function (o) {
                return subject.subscribe(o);
            }
        };
    }
})();
